document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.imago-gender-btn');
  const cards = document.querySelectorAll('.product-card-wrapper');

  buttons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      buttons.forEach(function (b) {
        b.classList.remove('active');
      });
      this.classList.add('active');

      var tag = this.getAttribute('data-tag');

      cards.forEach(function (card) {
        var cardTags = card.getAttribute('data-tags') || '';
        var li = card.closest('li');
        var target = li || card;

        if (tag === 'all' || cardTags.indexOf(tag) !== -1) {
          target.style.display = '';
        } else {
          target.style.display = 'none';
        }
      });
    });
  });
});
